import { render, staticRenderFns } from "./CanteensPagination.vue?vue&type=template&id=1ee6f5c8&"
import script from "./CanteensPagination.vue?vue&type=script&lang=js&"
export * from "./CanteensPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports